import { View } from 'react-native'
import Page from '@shell/Page'
import CodeInput from '@ui/forms/CodeInput'
import { useState } from 'react'

export default function DevCodeInputPage() {
  const [value, setValue] = useState('')
  return (
    <Page title="Code Input">
      <View className="gap-8 p-16">
        <CodeInput value={value} setValue={setValue} />
      </View>
    </Page>
  )
}
